<template>
  <div class="d-flex flex-column min-vh-100">
    <!-- Скрываем Header на странице логина -->
    <Header v-if="$route.path !== '/login'" />
    <main class="flex-grow-1 pt-2 bg-light">
      <div class="container-fluid py-3">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import Header from '@/components/layout/AppHeader.vue'
// import Content from "@/components/layout/AppContent.vue";

export default {
  components: {
      // eslint-disable-next-line vue/no-reserved-component-names
      Header
  },
  computed : {
    currentUser() {
      return this.$store.state.auth.user
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0)
    }
  }
}
</script>

<style scoped>

.scrollToTop {
  position: sticky;

  bottom: 15px;
  background-color: #1B69B2;
  border: none;
  color: white;
  padding: 15px 20px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 12px;
}
.scrollToTop:hover{
  background-color: #0E4C85;
   color:white;
}
</style>
